import lozad from 'lozad';

/**
 * LazyLoading & Intersection Observer
*/

window.addEventListener('beforeprint', () => {
  const imgs = document.getElementsByClassName('b-lazy');
  for (let index = 0; index < imgs.length; index++) {
    const img = imgs[index];
    const src = img.dataset.src;
    if (!src) break;
    img.src = src;
  }

  if (typeof window.Drupal === 'object' && typeof window.Drupal.blazy === 'object') {
    window.Drupal.blazy.run().load(imgs, true);
  }
});

const sectionsObserver = lozad('[data-animated]', {
  rootMargin: '30px 0px'
});
sectionsObserver.observe();
